import { StoreRole } from '../enums';

/** Store staff (works in the admin panel), as opposed to CUSTOMER and COURIER. */
export const STAFF: StoreRole[] = [StoreRole.OWNER, StoreRole.ADMIN, StoreRole.MANAGER];

/** Roles allowed to manage store settings, staff, pricing and the catalog. */
export const ADMINS: StoreRole[] = [StoreRole.OWNER, StoreRole.ADMIN];
